import { useState } from 'react';

import type { ReviewContextDto } from '../../lib/api/endpoints';

export function EngineSummary({ summary }: { summary: ReviewContextDto['rulesSummary'] }) {
  const [expanded, setExpanded] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const problemRules = [...summary.brokenRules, ...summary.warnedRules];
  const allRules = summary.allRules;

  return (
    <section className="rounded border border-border bg-bg-muted p-4">
      <button
        type="button"
        className="flex min-h-11 w-full items-center justify-between gap-3 text-left"
        aria-expanded={expanded}
        onClick={() => setExpanded((value) => !value)}
      >
        <span className="text-sm font-medium">
          Plan submitted with {summary.passed} rules passed, {summary.warned} warnings,{' '}
          {summary.broken} blocks.
        </span>
        <span className="text-accent text-sm">{expanded ? 'Hide' : 'Show'}</span>
      </button>

      {expanded ? (
        <div className="mt-3 space-y-3">
          {problemRules.length > 0 ? (
            <div className="space-y-2">
              {problemRules.map((rule) => (
                <div
                  key={`${rule.code}-${rule.message}`}
                  className="rounded border border-border bg-bg p-3"
                >
                  <p className="text-sm font-medium">{rule.code}</p>
                  <p className="mt-1 text-sm text-text-muted">{rule.message}</p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-text-muted">No warnings or blocks at plan submission.</p>
          )}

          {showAll ? (
            <div className="flex flex-wrap gap-2">
              {allRules.map((rule) => (
                <span
                  key={rule.code}
                  className={`rounded-full border px-3 py-1 text-xs ${
                    rule.status === 'broken'
                      ? 'border-danger/50 bg-danger/10 text-danger'
                      : rule.status === 'warned'
                        ? 'border-warn/50 bg-warn/10 text-warn'
                        : 'border-border text-text-muted'
                  }`}
                >
                  {rule.code}: {rule.status}
                </span>
              ))}
            </div>
          ) : null}

          {allRules.length > 0 ? (
            <button
              type="button"
              className="text-accent min-h-11 text-sm font-medium"
              onClick={() => setShowAll((value) => !value)}
            >
              {showAll ? 'Hide all rules' : `Show all ${allRules.length}`}
            </button>
          ) : null}
        </div>
      ) : null}
    </section>
  );
}
